/*
 The Vue build version to load with the `import` command
 (runtime-only or standalone) has been set in webpack.base.conf with an alias.
*/
import Vue from 'vue';
import App from './App';
import router from './router';
import storage from './box/storage'
import axios from './box/http';
import lodash from 'lodash';
//import "babel-polyfill";
import './box/validator';
import { generateUniqueID, todayDate } from './box/common'
import hotUpdate from './box/hot_update.js'; //app热更新
import jpush from './box/jpush.js'; //极光推送
import md5 from 'js-md5';

// import VueMatomo from 'vue-matomo' //统计
// if (process.env.WAY != 'android') {
//   Vue.use(VueMatomo, {
//     host: 'https://click.gzhuanteng.com/',
//     siteId: 1,
//     // Changes the default .js and .php endpoint's filename
//     // Default: 'matomo'
//     trackerFileName: 'matomo',

//     // Overrides the autogenerated tracker endpoint entirely
//     // Default: undefined
//     // trackerUrl: 'https://example.com/whatever/endpoint/you/have',

//     // Overrides the autogenerated tracker script path entirely
//     // Default: undefined
//     // trackerScriptUrl: 'https://example.com/whatever/script/path/you/have',

//     // Enables automatically registering pageviews on the router
//     router: router,

//     // Enables link tracking on regular links. Note that this won't
//     // work for routing links (ie. internal Vue router links)
//     // Default: true
//     enableLinkTracking: true,

//     // Require consent before sending tracking information to matomo
//     // Default: false
//     requireConsent: false,

//     // Whether to track the initial page view
//     // Default: true
//     trackInitialView: true,

//     // Run Matomo without cookies
//     // Default: false
//     disableCookies: false,

//     // Require consent before creating matomo session cookie
//     // Default: false
//     requireCookieConsent: false,

//     // Enable the heartbeat timer (https://developer.matomo.org/guides/tracking-javascript-guide#accurately-measure-the-time-spent-on-each-page)
//     // Default: false
//     enableHeartBeatTimer: false,

//     // Set the heartbeat timer interval
//     // Default: 15
//     heartBeatTimerInterval: 15,

//     // Whether or not to log debug information
//     // Default: false
//     debug: false,

//     // UserID passed to Matomo (see https://developer.matomo.org/guides/tracking-javascript-guide#user-id)
//     // Default: undefined
//     userId: undefined,

//     // Share the tracking cookie across subdomains (see https://developer.matomo.org/guides/tracking-javascript-guide#measuring-domains-andor-sub-domains)
//     // Default: undefined, example '*.example.com'
//     cookieDomain: undefined,

//     // Tell Matomo the website domain so that clicks on these domains are not tracked as 'Outlinks'
//     // Default: undefined, example: '*.example.com'
//     domains: undefined,

//     // A list of pre-initialization actions that run before matomo is loaded
//     // Default: []
//     // Example: [
//     //   ['API_method_name', parameter_list],
//     //   ['setCustomVariable','1','VisitorType','Member'],
//     //   ['appendToTrackingUrl', 'new_visit=1'],
//     //   etc.
//     // ]
//     preInitActions: [],

//     // A function to determine whether to track an interaction as a site search
//     // instead of as a page view. If not a function, all interactions will be
//     // tracked as page views. Receives the new route as an argument, and
//     // returns either an object of keyword, category (optional) and resultsCount
//     // (optional) to track as a site search, or a falsey value to track as a page
//     // view.
//     // Default: false, i.e. track all interactions as page views
//     // Example: (to) => {
//     //   if (to.query.q && to.name === 'search') {
//     //     return { keyword: to.query.q, category: to.params.category }
//     //   } else {
//     //    return null
//     //   }
//     // }
//     trackSiteSearch: false,

//     // Set this to include crossorigin attribute on the matomo script import
//     // Default: undefined, possible values : 'anonymous', 'use-credentials'
//     crossOrigin: undefined,
//   });

//   window._paq.push(['trackPageView']); // To track a page view
// }


// 插件
import Method from './box/method'
Vue.use(Method)

import Catcher from './box/catcher'
Vue.use(Catcher)

import {
  Button,
  Card,
  Cell,
  CellGroup,
  Checkbox,
  CheckboxGroup,
  Circle,
  Col,
  Collapse,
  CollapseItem,
  Dialog,
  DropdownItem,
  DropdownMenu,
  Field,
  Grid,
  GridItem,
  Icon,
  Image,
  ImagePreview,
  Info,
  Lazyload,
  List,
  Loading,
  NavBar,
  NoticeBar,
  Notify,
  Overlay,
  PasswordInput,
  Popup,
  PullRefresh,
  Radio,
  RadioGroup,
  Row,
  Search,
  SubmitBar,
  Swipe,
  SwipeItem,
  Tab,
  Tabbar,
  TabbarItem,
  Tabs,
  Tag,
  Toast,
  Sidebar,
  SidebarItem,
  Divider,
  Empty,
  CouponCell,
  CouponList,
  Sticky
} from 'vant';
import 'vant/lib/button/style';


import 'vant/lib/index.css'
import 'vant/lib/icon/local.css'; //引用local字体css
import './assets/css/css.css'
import './assets/css/iconfont.css'
import './assets/css/colorui.css'

Vue.use(Button)
  .use(Cell)
  .use(CellGroup)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Circle)
  .use(Col)
  .use(Collapse)
  .use(CollapseItem)
  .use(Dialog)
  .use(Field)
  .use(Grid)
  .use(GridItem)
  .use(Icon)
  .use(Image)
  .use(ImagePreview)
  .use(Info)
  .use(Lazyload)
  .use(List)
  .use(Loading)
  .use(NoticeBar)
  .use(Notify)
  .use(Overlay)
  .use(PasswordInput)
  .use(Popup)
  .use(PullRefresh)
  .use(Radio)
  .use(RadioGroup)
  .use(Row)
  .use(Search)
  .use(Swipe)
  .use(SwipeItem)
  .use(SubmitBar)
  .use(Tab)
  .use(Tabbar)
  .use(TabbarItem)
  .use(Tabs)
  .use(NavBar)
  .use(Tag)
  .use(DropdownItem)
  .use(DropdownMenu)
  .use(Card)
  .use(Sidebar)
  .use(SidebarItem)
  .use(Divider)
  .use(Sticky)
  .use(Empty)
  .use(CouponCell)
  .use(CouponList)
  .use(Toast);


//Vue.prototype.$dialog = Dialog;//已设置
Vue.prototype.$alert = Dialog.alert;
Vue.prototype.$confirm = Dialog.confirm;
//Vue.prototype.$notify = Notify;//设置
//Vue.prototype.$message = Toast;//设置
Vue.prototype.$message = Toast;


Vue.prototype.$storage = storage;
const defaultTitle = "推介网"


let domain = 'https://www.tuijiewang.com';
let site;
let baidu_id;

//cordova vue 组件使用前使用集成javacript
//import "babel-polyfill"; //cordova
//cordova vue 组件使用前使用集成javacript

//获取app版本号
var getVersion = function () {
  try {
    cordova.getAppVersion.getVersionNumber().then(version => {
      console.log(version)
    })
  } catch (exception) {
    console.log('getAppVersion error', exception);
  }
}

switch (process.env.WAY) {
  case 'h5':
    site = 'm.tuijiewang.com';
    //百度统计ID todo
    baidu_id = 'a203ee237ad11d007dde5a89613ff199';
    document_add_script('sohu', '//pv.sohu.com/cityjson?ie=utf-8');
    // Vue.use(VueMatomo, {
    //   host: 'https://click.gzhuanteng.com/',
    //   siteId: 1,
    //   router: router, // Vue 路由器实例
    //   // debug: true,
    // });
    break;
  case 'android':
    site = 'android';
    baidu_id = '';

    document_add_script('cordova_js', 'cordova.js');
    document_add_script('cordova_plugins_js', 'cordova_plugins.js');
    hotUpdate.initialize();

    jpush.initialize();
    // 获取点击状态栏中的通知内容时
    document.addEventListener("jpush.openNotification", (event) => {
      jpush.onOpenNotificationM(event, (content, extra) => {
        console.log('content', content)
        if (extra.type == 1) { //暂只有一个推送
          router.push({
            name: 'Follow',
          })
        }
      })
    }, false);
    //获取版本号
    document.addEventListener('deviceready', () => {
      getVersion()

      // 初始化WebView Referer拦截器 - 确保在主线程执行
      if (window.WebViewReferer) {
        // 使用cordova.exec确保在主线程执行
        cordova.exec(
          function(success) {
            console.log('WebView Referer拦截器初始化成功:', success);
          },
          function(error) {
            console.error('WebView Referer拦截器初始化失败:', error);
          },
          'WebViewReferer',
          'enable',
          []
        );
      } else {
        console.warn('WebViewReferer插件未找到，可能在浏览器环境中运行');
      }
      
      new Vue({
        el: '#app',
        router,
        components: { App },
        template: '<App/>'
      })
    }, false);

    break;
  default:
    site = 'no site';
    baidu_id = '';
    break;
}

/**
 * 动态添加script
 * @param {*} id 
 * @param {*} src 
 */
function document_add_script(id, src) {
  let script = document.createElement("script");
  script.src = src;
  script.id = id;
  // 保证JS顺序执行！
  script.async = false
  document.body.appendChild(script);
}

/* 统计代码 */
// if (baidu_id) {
//   router.afterEach((to, from, next) => {
//     setTimeout(() => {
//       var _hmt = _hmt || [];
//       (function () {
//         let id = 'baidu_tj';
//         //每次执行前，先移除上次插入的代码
//         document.getElementById(id) && document.getElementById(id).remove();
//         document_add_script(id, "https://hm.baidu.com/hm.js?" + baidu_id);
//       })();
//     }, 0);
//   });
// }


router.beforeEach((to, from, next) => {

  if (to.matched.length === 0) { //404页面，暂跳回首页
    next({
      path: '/home',
    })
  } else {
    //微信兼容
    if (_global.back && to.name == 'WxLogin') {
      next({
        path: '/home',
      })
      return;
    }
    document.title = to.meta.title ? defaultTitle + '--' + to.meta.title : defaultTitle
    const token = storage.get('token');
    get_msg();
    token && check_award();
    if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
      if (token) { // 通过vuex state获取当前的token是否存在
        next();
      } else {
        storage.set('from', to.name);
        next({
          // path: '/loginMobile',
          path: '/login',
          query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
        })
      }
    } else {
      // 检测路由是否存在，防止出现空白页
      //storage.set('from', {url:from.name || '',params:from.params || {}});
      //storage.set('from', from.path || '');
      //排除地址
      let names = ['LoginMobile', 'Login'];
      if (from.name == 'CenterLogin') {
        storage.set('from', 'Center');
      } else if (names.indexOf(from.name) === -1) {
        storage.set('from', from.path || '');
      }

      next();
    }

  }

})

Vue.config.productionTip = false;
Vue.prototype.$http = axios;
Vue.prototype.$lo = lodash;


/* 消息通知 */
function get_msg() {
  var unique_id = storage.get('unique_id');
  if (!unique_id) {
    const user_random_id = generateUniqueID();
    const user_agent = navigator.userAgent;
    unique_id = md5(user_agent + user_random_id);
    storage.set('unique_id', unique_id);
  }
  // console.log('get_msg', unique_id)
  let data = { unique_id };
  axios.post('get_msg', data).then((res) => {
    if (res.code == 1) {
      let data = res.data;
      if (data.type == 1) {
        let message = { 'content': data.content, 'link_m': data.link_m }
        storage.set('message', message);
      } else {
        // data.link_m = 'https://www.wjx.cn/vm/YDxYbp7.aspx?v=26#'
        if (data.link_m) {
          Dialog.confirm({
            title: data.title || '通知',
            message: data.content,
            confirmButtonText: '查看'
          }).then(() => {
            if ((data.link_m).indexOf('https://') == -1) {
              router.push({
                path: data.link_m,
              })
            } else {
              if (process.env.WAY == 'h5') {
                window.open(data.link_m, "_blank");
              } else {
                cordova.InAppBrowser.open(data.link_m, '_system', 'location=yes');;
              }
            }
          })
        } else {
          Dialog.alert({
            title: data.title || '通知',
            message: data.content,
          })
        }
      }
    }
  }).catch(err => {
    console.log('get_msg err:', err);
  })
}

/*登陆有奖*/
var check_award_lock = false; //锁
function check_award() {
  let today = todayDate();
  let award_day = storage.get('award_day');
  if (award_day != today && check_award_lock == false) {
    check_award_lock = true;
    axios.post('check_award').then((res) => {
      if (res.code == 1) {
        storage.set('award_day', today);
        console.log('今天已赠送');
      } else if (res.code == 2) {
        storage.set('award_day', today);
        //登录有奖提示
        Dialog.confirm({
          title: '登录有奖',
          message: res.memo,
          confirmButtonText: '确认',
          cancelButtonText: '详情'
        }).then(() => {
          router.push({
            name: 'Center',
          })
        }).catch(() => {
          // on cancel详情跳到金豆明细
          router.push({
            name: 'Centermagic',
          })
        });
      } else {
        console.log('未登录');
      }
      check_award_lock = false;
    }).catch(err => {
      check_award_lock = false;
      console.log('check_award err:', err);
    })
  }
  // else {
  //   console.log('今天执行已赠送', today);
  // }
}

/* 全局变量 */
window._global = { back: false, site: 'm.tuijiewang.com', qiniu: 'https://q.tuijiewang.com', domain, cancel: null, ad_show: true, way: process.env.WAY };
/* eslint-disable no-new */
// 如果Cordova未加载，直接启动Vue（用于浏览器开发）
if (!window.cordova) {
  new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
  })
}



// WEBPACK FOOTER //
// ./src/main.js